// NGRX
import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';

// Models
import { QueryParamsModel } from '../../_base/crud';
// CRUD
import { User } from '../_models/user.model';

export enum UserActionTypes {
  AllUsersRequested = '[Users Module] All Users Requested',
  AllUsersLoaded = '[Users API] All Users Loaded',
  UserOnServerCreated = '[Edit User Component] User On Server Created',
  UserCreated = '[Edit User Dialog] User Created',
  UserUpdated = '[Edit User Dialog] User Updated',
  UserDeleted = '[Users List Page] User Deleted',
  UsersPageRequested = '[Users List Page] Users Page Requested',
  UsersPageLoaded = '[Users API] Users Page Loaded',
  UsersPageCancelled = '[Users API] Users Page Cancelled',
  UsersPageToggleLoading = '[Users] Users Page Toggle Loading',
  UsersActionToggleLoading = '[Users] Users Action Toggle Loading',
  UserErrored = '[User API] User Error Occured',
  SaveSuccess = '[User API] Save Success',
  UserLoaded = '[Users API] User Loaded',
  FetchUser = '[Users API] Fetch User from Server',
}

export class FetchUser implements Action {
  readonly type = UserActionTypes.FetchUser;
  constructor(public payload: { id: number }) {}
}

export class AllUsersRequested implements Action {
  readonly type = UserActionTypes.AllUsersRequested;
}

export class AllUsersLoaded implements Action {
  readonly type = UserActionTypes.AllUsersLoaded;
  constructor(public payload: { users: User[] }) {}
}

export class UserLoaded implements Action {
  readonly type = UserActionTypes.UserLoaded;
  constructor(public payload: { user: User }) {}
}

export class SaveSuccess implements Action {
  readonly type = UserActionTypes.SaveSuccess;
  constructor(public payload: any) {}
}
export class AddUserError implements Action {
  readonly type = UserActionTypes.UserErrored;
  constructor(public payload: any) {}
}
export class UserOnServerCreated implements Action {
  readonly type = UserActionTypes.UserOnServerCreated;
  constructor(public payload: { user: User }) {}
}

export class UserCreated implements Action {
  readonly type = UserActionTypes.UserCreated;
  constructor(public payload: { user: User }) {}
}

export class UserUpdated implements Action {
  readonly type = UserActionTypes.UserUpdated;
  constructor(
    public payload: {
      partialUser: Update<User>;
      user: User;
    }
  ) {}
}

export class UserDeleted implements Action {
  readonly type = UserActionTypes.UserDeleted;
  constructor(public payload: { id: number }) {}
}

export class UsersPageRequested implements Action {
  readonly type = UserActionTypes.UsersPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class UsersPageLoaded implements Action {
  readonly type = UserActionTypes.UsersPageLoaded;
  constructor(
    public payload: {
      users: User[];
      totalCount: number;
      page: QueryParamsModel;
    }
  ) {}
}

export class UsersPageCancelled implements Action {
  readonly type = UserActionTypes.UsersPageCancelled;
}

export class UsersPageToggleLoading implements Action {
  readonly type = UserActionTypes.UsersPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class UsersActionToggleLoading implements Action {
  readonly type = UserActionTypes.UsersActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export type UserActions =
  | UserCreated
  | UserUpdated
  | UserDeleted
  | UserOnServerCreated
  | UsersPageLoaded
  | UsersPageCancelled
  | UsersPageToggleLoading
  | UsersPageRequested
  | UsersActionToggleLoading
  | AddUserError
  | SaveSuccess
  | UserLoaded
  | AllUsersRequested
  | AllUsersLoaded
  | FetchUser;
